module.exports = __webpack_public_path__ + "assets/b232389e30e05a96e8df1670fc141717.mp3";